<div [ngClass]="{'fx-justify-end': isNumericalColumn ,'fx-justify-space-between': !isNumericalColumn}"
  class="ag-cell-editor fx-layout-row fx-align-center fx-gap-5">
  <div>
    {{ params.valueFormatted }}
  </div>
  <div class="fx-layout-row">
    @if (formControl.invalid) {
      <div [matTooltip]="params.customErrorMessage" (click)="onClickTooltip(tooltip)">
        <mat-icon fontSet="mdi" fontIcon="mdi-help-circle" aria-hidden="true" class="tooltip-icon"></mat-icon>
      </div>
    }
    <div [matTooltipPosition]="'below'" [matTooltip]="'TOOLTIP.COMPUTED_VALUE' | translate" #tooltip="matTooltip"
      (click)="onClickTooltip(tooltip)">
      <mat-icon fontSet="mdi" fontIcon="mdi-calculator" aria-hidden="true" class="tooltip-icon"></mat-icon>
    </div>
  </div>
</div>
